import { createSelector } from 'redux-orm';

import orm from '../orm';
import {
  selectPointSystemForCurrentBoard,
  makeSelectPointSystemByBoardId,
} from './point-systems';

const plansForPointSystemId = (EmployeePlan, pointSystemId) => {
  if (!pointSystemId) {
    return [];
  }

  const id = String(pointSystemId);

  // String() — иначе filter({ pointSystemId }) может не совпасть (string vs number)
  return EmployeePlan.all()
    .toRefArray()
    .filter((plan) => String(plan.pointSystemId) === id)
    .sort((a, b) => (Number(a.sort) || 0) - (Number(b.sort) || 0));
};

export const selectEmployeePlansForCurrentBoardPointSystem = createSelector(
  orm,
  (state) => selectPointSystemForCurrentBoard(state),
  ({ EmployeePlan }, pointSystem) => plansForPointSystemId(EmployeePlan, pointSystem?.id),
);

export const makeSelectEmployeePlansByPointSystemId = () =>
  createSelector(
    orm,
    (_, pointSystemId) => pointSystemId,
    ({ EmployeePlan }, pointSystemId) => plansForPointSystemId(EmployeePlan, pointSystemId),
  );

export const selectEmployeePlansByPointSystemId = createSelector(
  orm,
  (_, pointSystemId) => pointSystemId,
  ({ EmployeePlan }, pointSystemId) => plansForPointSystemId(EmployeePlan, pointSystemId),
);

/**
 * Планы уровней для отчёта: board-level PointSystem доски.
 */
export const makeSelectEmployeePlansForBoardReport = () => {
  const selectPointSystemByBoardId = makeSelectPointSystemByBoardId();

  return createSelector(
    orm,
    (state, boardId) => selectPointSystemByBoardId(state, boardId),
    ({ EmployeePlan }, pointSystem) => plansForPointSystemId(EmployeePlan, pointSystem?.id),
  );
};

export default {
  selectEmployeePlansForCurrentBoardPointSystem,
  makeSelectEmployeePlansByPointSystemId,
  selectEmployeePlansByPointSystemId,
  makeSelectEmployeePlansForBoardReport,
};
